import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import Theme from '../../../styles/Theme/Theme';

const SemiCircle = ({ data }) => {
  const value = data ?? 0;
  const containerRef = useRef(null);
  const [w, setW] = useState(200);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const ro = new ResizeObserver(([entry]) => {
      const { width } = entry.contentRect;
      if (width > 0) setW(Math.round(width));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  let color, label, trackColor;
  if (value <= 25) {
    color = Theme.color['critical-base'];
    label = 'Bad';
    trackColor = Theme.color['critical-light'];
  } else if (value <= 60) {
    color = Theme.color['medium-base'];
    label = 'Medium';
    trackColor = Theme.color['medium-light'];
  } else {
    color = Theme.color['low-base'];
    label = 'Good';
    trackColor = Theme.color['low-light'];
  }

  const valueFontSize = Math.max(16, Math.min(48, Math.round(w * 0.18)));
  const labelFontSize = valueFontSize;

  const options = {
    colors: [color],
    chart: {
      type: 'radialBar',
      background: 'transparent',
      toolbar: { show: false },
      animations: { enabled: false },
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: trackColor,
          strokeWidth: '100%',
          margin: 0,
        },
        dataLabels: {
          name: {
            show: true,
            offsetY: Math.round(w * 0.06),
            color: Theme.color['coolgray-10'],
            fontSize: `${labelFontSize}px`,
          },
          value: {
            show: true,
            offsetY: -Math.round(w * 0.10),
            fontWeight: 'bold',
            color: Theme.color['black-1'],
            fontSize: `${valueFontSize}px`,
            formatter: (val) => `${Math.round(val)}%`,
          },
        },
        hollow: { margin: 0, size: '50%' },
      },
    },
    stroke: { lineCap: 'round' },
    labels: [label],
    // Aggressive negative padding removes ApexCharts internal whitespace
    grid: { padding: { top: -Math.round(w * 0.04), bottom: 0, left: -Math.round(w * 0.30), right: -Math.round(w * 0.30) } },
  };

  // The chart renders as a square; we only show the top ~72% (the arc half + labels)
  const visibleH = Math.round(w * 0.72);

  return (
    <div ref={containerRef} style={{ width: '100%', overflow: 'hidden', height: `${visibleH}px` }}>
      <ReactApexChart
        options={options}
        series={[value]}
        type="radialBar"
        width={w}
        height={w}
      />
    </div>
  );
};

export default SemiCircle;